// ** React Imports
import {Navigate} from 'react-router-dom'
import {Suspense, useContext, useEffect} from 'react'

// ** Context Imports
import {AbilityContext} from '@src/utility/context/Can'

const PrivateRoute = ({children, route}) => {
    // ** Hooks & Vars
    const ability = useContext(AbilityContext)
    const user = JSON.parse(localStorage.getItem('userData'))

    const handleNoUserData = e => {
        if (route && user && e.key === 'isLoggedIn' && e.oldValue === '1' && e.newValue !== '1') {
            window.location.href = '/login'
        }
    }

    useEffect(() => {
        window.addEventListener('storage', handleNoUserData)
        return () => window.removeEventListener('storage', handleNoUserData)
    }, [])

    if (route) {
        let action = null
        let resource = null
        let restrictedRoute = false

        if (route.meta) {
            action = route.meta.action
            resource = route.meta.resource
            restrictedRoute = route.meta.restricted
        }
        if (!user) {
            return <Navigate to='/login'/>
        }
        if (user && restrictedRoute) {
            return <Navigate to='/'/>
        }
        if (user && !ability.can(action, resource)) {
            return <Navigate to='/misc/not-authorized' replace/>
        }
    }

    return <Suspense fallback={null}>{children}</Suspense>
}

export default PrivateRoute
